
interface PublicRoutesProps {
  children: JSX.Element | null;
}

const PublicRoute = ({ children }: PublicRoutesProps) => {
  return children;
};

export default PublicRoute;
